

import { BaseEntity, CommonSettingEntity } from '@m4u-angular/base/entities/BaseEntities';

export class ContactPerson extends BaseEntity
{   
    public CustomerID: number; 
    public Name: string; 
    public CardName: string; 
    public Password: string; 
    public Position: string; 
    public Phone: string; 
    public Cellular: string; 
    public Email: string; 
    public IsDefault: boolean; 
    public IsActive: boolean; 
	
}



